
<template>
  <!--平台优选-->
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :rowOptLen="4"
      :dataSource="dataSource"
      rowKey="warehouse_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_o" slot-scope="{row}">
        <span>{{row.title}}</span>
        <a-icon v-if="row.is_recommend" type="home" theme="twoTone" twoToneColor="#eb2f96"/>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'goodsWarehouse',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '标题', options: [], inputType: 'input' },
        { props: ['create_time'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        create_time: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:goodsWarehouse:add'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:goodsWarehouse:edit'] },
        { text: '编辑商品', handle: (record) => this.toEditGoods(record), permi: ['community:goodsWarehouse:editGoods'] },
        {
          text: '设为推荐',
          handle: (record) => this.setRecommend(record),
          rowOptText: record => this.rowOptText(record),
          rowOptDisHandle: this.commendDisable,
          customRender: true,
          permi: ['community:goodsWarehouse:recommend']
        },
        {
          text: '删除',
          handle: (record) => this.$refs.table.showDeleteConfirm(record, record.community_name),
          rowOptDisHandle: this.delDisable,
          permi: ['community:goodsWarehouse:remove']
        }
      ],
      columns: [
        { title: '标题', dataIndex: 'title', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '商品数', dataIndex: 'goods_sum', align: 'left', width: '' },
        { title: '访客数', dataIndex: 'member_view_sum', align: 'left', width: '' },
        { title: '浏览量', dataIndex: 'pageview', align: 'left', width: '' },
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/market/goods_warehouse',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addWarehouse',
        addTitle: '新增选品库',
        editTitle: '修改选品库'
      },
      deleteParam: {
        url: '/market/goods_warehouse',
        param: {pk_key: 'warehouse_id', pk_val: ''},
        title: '选品库',
        key: 'title'
      }
    };
  },
  mounted () {
  },
  methods: {
    /** 处理处理删除按钮禁用 */
    delDisable (record, item) {
      if (record.is_recommend === 1) {
        return true;
      } else {
        return false;
      }
    },
    /** 处理设为推荐禁用 */
    commendDisable (record, item) {
      if (record.goods_sum === 0) {
        return true;
      }
    },
    /** 处理设为推荐展示文本 */
    rowOptText (record) {
      if (record.is_recommend) {
        return '取消推荐';
      } else {
        return '设为推荐';
      }
    },
    /** 设为推荐 */
    setRecommend (record) {
      this._post({
        url: '/market/warehouse_recommend',
        params: {
          warehouse_id: record.warehouse_id,
          status: record.is_recommend === 0 ? 1 : 0
        }
      }).then(({data}) => {
        this.$message.success(record.is_recommend === 0 ? '设为推荐成功' : '取消推荐成功');
        this.$refs.table.getTableList();
      });
    },
    /** 进入编辑商品页面 */
    toEditGoods (record) {
      this.setLocal('warehouseId', record.warehouse_id);
      this.$router.push({
        name: 'editGoods',
        query: { id: record.warehouse_id, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
